import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationStart, Event as NavigationEvent } from '@angular/router';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  isTop: boolean = true;

  @HostListener('window:scroll')
	onScroll() {
    if (window.scrollY <= 0) {
      this.isTop = true;
    } else {
      this.isTop = false;
    }
	}

  constructor(router: Router) {
    router.events.forEach((event: NavigationEvent) => {
    			if (event instanceof NavigationStart) {
    				window.scrollTo(0,0);
    			}
    		});
   }

  ngOnInit() {  }

}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts